/* @flow strict */

/* eslint-disable camelcase */

import * as React from 'react';
import _ from 'lodash';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer.js';
import { convertToLocalTime } from '/client/src/utils/jstz';
import Modal from '/client/src/components/Modal';
import SimpleCheckbox from '/client/src/components/forms/checkbox';
import ReactSummernote from 'react-summernote';
import { SummenrNoteToolbar } from '/client/src/constants/';

import './styles.scss';

type PropsType = {
    isOpen: boolean,
    handleShowModal: (boolean) => void,
    handleConfirm: (data: any) => void,
    eventDetail: {
        begin_time_utc: string,
        time_zone_id: string,
        show_event_time_and_date: boolean,
        name: string
    }
};

class RefundAllEmailModal extends React.Component<PropsType> {
    static contextType = DefaultContainerContext;

    state = {
        isShow: null,
        isEmailSendChecked: true,
        refundMessage: `Hello {name},<br/><br/>
        The amount of {ticket price} will be refunded  for your ticket with ticket code: {code} for ${_.get(this.props, 'eventDetail.name', '-')} on
        ${convertToLocalTime(_.get(this.props, 'eventDetail.begin_time_utc', null), _.get(this.props, 'eventDetail.time_zone_id', null), 'DD/MM/YY h:mm a z')}.<br/><br/>
        Although this refund has been processed, it may take up to 7 business days for the refund to appear on your bank or credit card statement.<br/><br/>
        Please contact your event organizer if you have any questions: ${_.get(this.props, 'eventDetail.confirmation_email_support_email', '-')}`
    }

    componentDidMount() {
        const { res } = this.convertMustacheTags(this.state.refundMessage);

        this.setState({
            refundMessage: res
        });
    }

    handleClose = (): any => {
        const { handleShowModal } = this.props;

        handleShowModal(false);
    };

    handleConfirm = (): any => {
        const { refundMessage, isEmailSendChecked } = this.state;
        const data = {
            refund_message: refundMessage
                .replaceAll('<span class="mustache-tag">', '')
                .replaceAll('</span>', '')
                .replaceAll('&nbsp;', '')
                .replace(/\{(.*?)\}/g, (x) => x.toLowerCase()),

            send_email: isEmailSendChecked
        };

        this.props.handleConfirm(data);
    }

    convertMustacheTags = (content: string): any => {
        let res;

        let currentTagIndex;

        let tagIndex = 0;

        res = content.replace(/<span[^>]*>/g, (x) => { // erase all
            return x;
        });

        res = res.replace(/\{(.*?)\}/g, (x, e, i, content): any => {
            tagIndex++;
            if (content.slice(i - 27, i) === '<span class="mustache-tag">') { // prevent if already has class
                return x;
            }
            currentTagIndex = tagIndex - 1;
            return `<span class="mustache-tag">${x}</span><span>&nbsp;</span>`;
        });
        return {
            res,
            currentTagIndex
        };
    }
    updateCaret = (tagIndex: number) => {
        const editor = document.querySelector('.note-editor');
        const content = editor.querySelector('[contenteditable]');
        const node = content.querySelectorAll('.mustache-tag')[tagIndex];
        const range = document.createRange();

        range.setStartAfter(node.nextSibling, 1);
        range.setEndAfter(node.nextSibling, 1);
        const sel = window.getSelection();

        sel.removeAllRanges();
        sel.addRange(range);
    }

    handleMessage = (content: string) => {
        const { res, currentTagIndex } = this.convertMustacheTags(content);

        this.setState({
            refundMessage: res
        }, () => {
            currentTagIndex && this.updateCaret(currentTagIndex);
        });
    }

    initMustacheTags = () => {
        const mustacheContainer = document.createElement('div');

        mustacheContainer.style.margin = '4px 0 14px 0';
        const mustacheTags = ['name', 'ticket price', 'code'];
        const mustacheTagsInnerHTML = mustacheTags.map((tag: any): any => (
            `<span style='
                background: #fc2861;
                color: white;
                padding: 3px 8px;
                font-size: 14px;
                margin-right: 8px;
                border-radius: 3px;
                '>{${tag}}
            </span>`
        ));

        mustacheContainer.innerHTML = mustacheTagsInnerHTML.join('');
        const editor = document.querySelector('.note-editor');

        if (!editor) return;
        editor.parentNode.insertBefore(mustacheContainer, editor.parentNode.firstChild);
    }

    render(): React.Element {
        const { isOpen } = this.props;
        const { isEmailSendChecked, refundMessage } = this.state;

        return (
            <Modal
              opened={isOpen}
              onClose={this.handleClose}
              altView
              isScrollable
            >
                <div className="modal-dialog modal-lg customModal EventPageDetailCustomersModal modal-table-filter" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">
                                <span className="icon icon-ticket modal-icon modal-icon-pink" style={{ marginRight: '2rem' }} />
                                <span>
                                    Refund All Tickets
                                </span>
                            </h4>
                        </div>
                        <div className="modal-body" style={{ paddingBottom: '50px', minHeight: 110, position: 'relative' }}>
                            <div style={{ marginBottom: '25px', color: 'grey' }}>
                                Refund All Tickets will make sure every ticket is refunded for the whole event. Choose to customize an email message and continue to the confirmation page.
                            </div>
                            <SimpleCheckbox
                              label='Send Email'
                              checked={isEmailSendChecked}
                              callBack={(status: boolean) => {
                                    this.setState({
                                        isEmailSendChecked: status
                                    });
                                }}
                            />
                            {isEmailSendChecked &&
                                <div className="form-group">
                                    <label htmlFor="refundMessage">Add customized email message to guests here. You can use these tags:</label>
                                    <ReactSummernote
                                      children={<div dangerouslySetInnerHTML={{ __html: refundMessage }} />}
                                      options={{
                                            lang: 'en-US',
                                            height: 170,
                                            dialogsInBody: true,
                                            toolbar: SummenrNoteToolbar
                                        }}
                                      onChange={(data: string) => {
                                            this.handleMessage(data);
                                        }}
                                      onInit={() => {
                                            this.initMustacheTags();
                                        }}
                                    />
                                </div>
                            }
                        </div>
                        <div
                          className="modal-footer"
                        >
                            <button className="btn btn-gray" onClick={(): any => this.handleClose()}>Cancel</button>
                            <button
                              className="btn btn-pink"
                              onClick={(): void => this.handleConfirm()}
                            >Continue</button>

                        </div>
                    </div>
                </div>

            </Modal>
        );
    }
}

export default RefundAllEmailModal;
